import { DocumentsController } from './documents.controller'
import { EditorController } from './pages/editor/editor.controller'

const checkModuleEnabled = [
  '$q',
  '$state',
  '$rootScope',
  '$translate',
  'ToastService',
  async ($q, $state, $rootScope, $translate, ToastService) => {
    const deferred = $q.defer()
    const promises = [$rootScope.getUser(), $rootScope.getCompanyFeatures()]

    $q.all(promises).then(([user, companyFeatures]) => {
      if (Array.isArray(companyFeatures) && companyFeatures.includes('DOCUMENTS_MODULE') && $rootScope.isUserSysAdminAdminDesigner(user)) {
        deferred.resolve()
      } else {
        deferred.reject()
      }
    })

    return deferred.promise.catch(() => {
      ToastService.showErrorToast($translate.instant('documentsModule.accessDenied'))
      $state.go('home')
    })
  }
]

/* @ngInject */
function routes ($stateProvider) {
  $stateProvider
    .state('documents', {
      url: '/documents',
      resolve: {
        checkModuleEnabled
      },
      views: {
        '': {
          templateUrl: '/documents/documents.html?$$REVISION$$',
          controller: DocumentsController
        }
      }
    })
    .state('documents.editor', {
      parent: 'documents',
      url: '/editor/:id?goBackRoute&template&readOnly',
      params: {
        template: { value: null, squash: true },
        readOnly: { value: null, squash: true },
        goBackRoute: { value: null, squash: true }
      },
      views: {
        'editor@documents': {
          templateUrl: '/documents/pages/editor/editor.html?$$REVISION$$',
          controller: EditorController
        }
      }
    })
}

export const documentsRoutes = routes
